import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { ApiError } from "../../api/errors";
import {
	AgentsData,
	ApprovedSend,
	CreatedLink,
} from "../../api/schemas/agents";
import { CreatedApiKey } from "../../api/schemas/integrations";
import { Dialog } from "../../widgets/dialog";
import * as Picker from "../../widgets/recordPicker";

export const Message = defineMessageUnion({
	CompletedFetch: {
		generation: S.Number,
		result: S.Result(AgentsData, ApiError),
	},
	/** A background refetch; `after` is the `now` of the data it follows, so stray loops drop out. */
	CompletedRefresh: {
		generation: S.Number,
		after: S.Number,
		result: S.Result(AgentsData, ApiError),
	},
	ClickedPromote: { contextId: S.String, title: S.String },
	ClickedRevoke: { contextId: S.String, title: S.String },
	ClickedConfirm: {},
	GotDialogMessage: { message: Dialog.Message },
	ChangedAgentName: { value: S.String },
	SubmittedConnect: {},
	CompletedCreateKey: {
		generation: S.Number,
		name: S.String,
		result: S.Result(CreatedApiKey, ApiError),
	},
	ClickedCopyKey: {},
	CopyFeedbackExpired: {},
	ClickedDoneConnect: {},
	ChangedShareAgent: { value: S.String },
	ChangedShareLabel: { value: S.String },
	GotPickerMessage: { message: Picker.Message },
	SubmittedShare: {},
	CompletedCreateLink: {
		generation: S.Number,
		label: S.String,
		result: S.Result(CreatedLink, ApiError),
	},
	ClickedCopyLink: {},
	LinkCopyExpired: {},
	ClickedDoneShare: {},
	ClickedRevokeLink: { id: S.String, label: S.String },
	ClickedApprove: { id: S.String },
	ClickedDeny: { id: S.String },
	CompletedApprove: {
		generation: S.Number,
		to: S.String,
		result: S.Result(ApprovedSend, ApiError),
	},
	ClickedDismissOutcome: {},
	GotPastePickerMessage: { message: Picker.Message },
	ChangedPasteUrl: { value: S.String },
	SubmittedPaste: {},
	CompletedPaste: {
		generation: S.Number,
		name: S.String,
		result: S.Result(S.Unknown, ApiError),
	},
	/** Any write settled; the body is not read, the page refetches. */
	CompletedWrite: {
		generation: S.Number,
		result: S.Result(S.Unknown, ApiError),
	},
});
export type Message = typeof Message.Type;
